// @flow

import * as React from 'react';
import track, { trackClick, type TrackingEventAJAXProps } from './tracking';

type GARecordTracker = () => mixed;

/**
 * A convenient hook to ensure click tracking is not done more than once per mount. If you don't care about duplicates, use track/trackClick directly instead
 * @param params The tracking parameters. See definition for more details
 * @param event Optional; the underlying synthetic event. Used to check if tracking should be done via AJAX or cookies
 * @returns A function to track
 */

const useGARecordEvent = (
  params: TrackingEventAJAXProps,
  event?: SyntheticEvent<*>,
): GARecordTracker => {
  const tracked = React.useRef(false);
  const { current: tracker } = React.useRef(() => {
    if (!tracked.current) {
      if (event) {
        trackClick(event, params);
      } else {
        track(params);
      }
      tracked.current = true;
    }
  });
  return tracker;
};

export default useGARecordEvent;
